module.exports = __webpack_public_path__ + "static/plastica-731810bf3146b3496855c9b2f7c2f171.png";